// Generated by ts-to-zod
import { z } from 'zod';
import { annotationListTableSchema } from '../../shared/models/annotationListTable.schema';
import { automationSettingsSchema } from './automationSettings.schema';
import { autopilotConfigSchema } from './autopilotConfig.schema';
import { emailNotificationsSettingsSchema } from './emailNotificationsSettings.schema';
import { rejectionSettingsSchema } from './rejectionSettings.schema';
import { suggestedRecipientSourcesSettingsSchema } from './suggestedRecipientSourcesSettings.schema';

export const queueSettingsColumnsSchema = z.object({
  schemaId: z.string(),
});

const queueSettingsUploadValueBaseSchema = z.object({
  id: z.string(),
  label: z.string(),
  required: z.boolean(),
  type: z.string().optional(),
});

const queueSettingsUploadValueEnumSchema = queueSettingsUploadValueBaseSchema.and(
  z.object({
    data_type: z.literal('enum'),
    enum_options: z.array(
      z.object({
        label: z.string(),
        value: z.string(),
      })
    ),
  })
);

const queueSettingsUploadValueStringSchema = queueSettingsUploadValueBaseSchema.and(
  z.object({
    data_type: z.literal('string'),
  })
);

export const queueSettingsUploadValuesSchema = z.union([
  queueSettingsUploadValueEnumSchema,
  queueSettingsUploadValueStringSchema,
]);

const queueSettingsEditValueBaseSchema = z.object({
  id: z.string(),
  label: z.string(),
  required: z.boolean(),
});

const queueSettingsEditValueEnumSchema = queueSettingsEditValueBaseSchema.and(
  z.object({
    dataType: z.literal('enum'),
    enumOptions: z.array(
      z.object({
        label: z.string(),
        value: z.string(),
      })
    ),
  })
);

const queueSettingsEditValueStringSchema = queueSettingsEditValueBaseSchema.and(
  z.object({
    dataType: z.literal('string'),
  })
);

export const queueSettingsEditValueSchema = z.union([
  queueSettingsEditValueEnumSchema,
  queueSettingsEditValueStringSchema,
]);

export const queueSettingsSchema = z
  .object({
    columns: z.array(queueSettingsColumnsSchema),
    hideExportButton: z.boolean(),
    autopilot: autopilotConfigSchema.nullable(),
    acceptedMimeTypes: z.array(z.string()),
    asynchronousExport: z.boolean(),
    automation: automationSettingsSchema,
    rejectionConfig: rejectionSettingsSchema,
    suggestedRecipientsSources: suggestedRecipientSourcesSettingsSchema,
    suggestedEdit: z.union([z.literal('suggest'), z.literal('disable')]),
    emailNotifications: emailNotificationsSettingsSchema,
    workflows: z
      .object({
        enabled: z.boolean(),
        bypassWorkflowsAllowed: z.boolean(),
      })
      .partial(),
    dashboardCustomization: z
      .object({
        allDocuments: z.boolean(),
      })
      .partial(),
    annotationListTable: annotationListTableSchema.optional(),
    uploadValues: z.unknown().optional(),
    complexTables: z.boolean().optional(),
    uiUploadEnabled: z.boolean().optional(),
    uiOnEditConfirm: z
      .union([
        z.literal('annotation_list'),
        z.literal('edit_next'),
        z.literal('validate_first'),
      ])
      .optional(),
    uiValidationScreenEnabled: z.boolean().optional(),
    uiEditValues: z.array(queueSettingsEditValueSchema).optional(),
    uiEditTargetQueueSelectionEnabled: z.boolean().optional(),
    uiEditAlwaysSplitDocument: z.boolean().optional(),
    memoryLearningMode: z
      .union([z.literal('automatic'), z.literal('manual')])
      .optional()
      .nullable(),
  })
  .partial();
